module.exports = __webpack_public_path__ + "static/media/outcome_anna.cacfaa5f.png";